export const build = { date:"2026-03-06.1617", stage:"alpha" }
